<template>
    <div>
        <b-modal
            :title="$t('Component(ProductAttributeModal):title')"
            ref="modal"
            centered
            no-close-on-backdrop
            @ok="addItem"
        >
            <div>
                <v-select
                    :options="availableOptions"
                    :placeholder="placeholder"
                    :getOptionKey="o => o.key"
                    :getOptionLabel="o => o.title"
                    v-model="selectedType"
                />
            </div>
        </b-modal>
        <b-form-group :label="label">
            <template #label>
                <div class="d-flex justify-content-between align-items-center">
                    {{ label }}
                    <div class="d-flex align-items-center">
                        <label v-if="showRadio" class="pr-lg-0 pr-xl-1 pr-xxl-1 pr-md-0 mr-md-0 pr-sm-0 mr-sm-3" style="width: 100px; text-align: center;">
                            {{ $t('Component(ProductAttribute):product-identifier-primary-key') }}
                        </label>
                        <Button @click="$refs.modal.show()" variant="primary" class="btn-icon">
                            <feather-icon
                                icon="PlusIcon"
                                class="cursor-pointer"
                            />
                        </Button>
                    </div>
                </div>
            </template>
            <b-row
                v-for="(value, index) in visibleItems"
                class="mr-0"
            >
                <b-col :sm="isRadioVisible(value.item) ? 8 : 9" :md="isRadioVisible(value.item) ? 10 : 11">
                    <b-form-group
                        v-if="isOther(value.item)"
                        :label="typeTitle(value.item)"
                        :label-for="'attribute-type' + id + value.index"
                    >
                        <b-row >
                            <b-col md="4">
                                <b-form-input
                                    :required="index === 0"
                                    :id="'attribute-type' + id + value.index"
                                    :placeholder="$t('Component(Placeholder):product-other-type')"
                                    v-model="value.item.value.type"
                                />
                            </b-col>
                            <b-col>
                                <b-form-input
                                    :required="index === 0"
                                    :id="'attribute' + id + value.index"
                                    :placeholder="valuePlaceholder"
                                    v-model="value.item.value.value"
                                />
                            </b-col>
                        </b-row>
                    </b-form-group>
                    <b-form-group
                        v-else
                        :label="typeTitle(value.item)"
                        :label-for="'attribute' + id + value.index"
                    >
                        <b-form-input
                            :required="index === 0"
                            :id="'attribute' + id + value.index"
                            :placeholder="valuePlaceholder"
                            v-model="value.item.value"
                            @input="onValueChange(value.index, value.item)"
                        />
                    </b-form-group>
                </b-col>
                <b-col v-if="isRadioVisible(value.item)" sm="2" md="1" class="p-0 d-flex align-items-center justify-content-around">
                    <div class="d-flex align-items-center">
                        <b-form-radio
                            :name="'radio' + id + value.index"
                            :value="value.index"
                            v-model="selectedRadioIndex"
                            @change="onRadioChange"
                        />
                    </div>
                </b-col>
                <b-col :sm="isRadioVisible(value.item) ? 2 : 3" :md="1" class="m-0 p-0">
                    <div
                        v-if="canRemove(value.index, value.item)"
                        class="d-flex align-items-center justify-content-end"
                        style="padding-top: 22px"
                    >
                        <Button @click="removeItem(value.index, value.item)" variant="danger" class="btn-icon">
                            <feather-icon
                                icon="MinusIcon"
                                class="cursor-pointer"
                            />
                        </Button>
                    </div>
                </b-col>
            </b-row>
            <AppCollapse type="border" v-if="this.values.filter(this.isAttributeVisible).length > this.numberOfVisibleItems">
                <AppCollapseItem
                    @visible="onHiddenElementsVisibilityChange"
                    :is-visible="isHiddenElementsVisible"
                    :title="hiddenElementsTitle"
                    ref="collapsedItems"
                >
                    <b-row
                        v-for="value in hiddenItems"
                        class="mr-0"
                    >
                        <b-col :sm="isRadioVisible(value.item) ? 8 : 9" :md="isRadioVisible(value.item) ? 10 : 11">
                            <b-form-group
                                v-if="isOther(value.item)"
                                :label="typeTitle(value.item)"
                                :label-for="'attribute-type' + id + value.index"
                            >
                                <b-row >
                                    <b-col md="4">
                                        <b-form-input
                                            :id="'attribute-type' + id + value.index"
                                            :placeholder="$t('Component(Placeholder):product-other-type')"
                                            v-model="value.item.value.type"
                                        />
                                    </b-col>
                                    <b-col>
                                        <b-form-input
                                            :id="'attribute' + id + value.index"
                                            :placeholder="valuePlaceholder"
                                            v-model="value.item.value.value"
                                        />
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group
                                v-else
                                :label="typeTitle(value.item)"
                                :label-for="'attribute' + id + value.index"
                            >
                                <b-form-input
                                    :id="'attribute' + id + value.index"
                                    :placeholder="valuePlaceholder"
                                    v-model="value.item.value"
                                    @input="onValueChange(value.index, value.item)"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col v-if="isRadioVisible(value.item)" sm="2" md="1" class="p-0 d-flex align-items-center justify-content-around">
                            <div class="d-flex align-items-center">
                                <b-form-radio
                                    :name="'radio' + id + value.index"
                                    :value="value.index"
                                    v-model="selectedRadioIndex"
                                    @change="onRadioChange"
                                />
                            </div>
                        </b-col>
                        <b-col :sm="isRadioVisible(value.item) ? 2 : 3" :md="1" class="m-0 p-0">
                            <div
                                v-if="canRemove(value.index, value.item)"
                                class="d-flex align-items-center justify-content-end"
                                style="padding-top: 22px"
                            >
                                <Button @click="removeItem(value.index, value.item)" variant="danger" class="btn-icon">
                                    <feather-icon
                                        icon="MinusIcon"
                                        class="cursor-pointer"
                                    />
                                </Button>
                            </div>
                        </b-col>
                    </b-row>
                </AppCollapseItem>
            </AppCollapse>

            <b-row v-if="values.length === 0">
                <b-col>
                    <b-alert
                        show
                        variant="warning"
                        class="mb-50"
                    >
                        <div class="alert-body">
                            {{ $t('Component(Text):nothing-selected') }}
                        </div>
                    </b-alert>
                </b-col>
            </b-row>
        </b-form-group>
    </div>
</template>
<script>
//  todo rewrite with emiting values to external component
import { BFormGroup, BFormInput, BCol, BRow, BButton, BModal, BAlert, BFormRadio, BCollapse } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Button from "@core/components/common/Button.vue";
import {ProductIdentifiers, ProductNames} from "@/libs/product";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

export default {
    components: {
        AppCollapse, AppCollapseItem,
        Button, BModal, BAlert, BFormGroup, vSelect, BFormInput, BCol, BRow, BButton, BFormRadio, BCollapse
    },
    directives: {
        Ripple,
    },
    props: {
        id: {
            required: true
        },
        label: {
            default: ''
        },
        showRadio: {
            default: false
        },
        showRadioForItem: {
            default: () => {
                return true;
            }
        },
        radioValue: {
            default: 0
        },
        options: {
            type: Array,
            required: true
        },
        placeholder: {
            type: String,
        },
        valuePlaceholder: {
            type: String,
        },
        selected: {
            type: Array,
            default() {
                return [];
            }
        },
        canRemove: {
            default() {
                return (index, value) => true;
            }
        },
        isAttributeVisible: {
            default() {
                return () => true;
            }
        },
        numberOfVisibleItems: {
            default: 3
        },
        hiddenElementsTitle: {
            default() {
                return 'Click here to see all items';
            }
        }
    },

    data() {
        return {
            selectedRadioIndex: this.radioValue,
            popoverShow: false,
            length: this.selected.length,
            values: this.selected ? this.prepareSelected(this.selected) : [],
            typeKeyTitleMap: {},
            selectedType: null,
            availableOptions: this.options.map(o => o),
            interval: null,
            expandHidden: false
        };
    },
    methods: {
        showRadioItem(item) {
            if (this.showRadioForItem && typeof this.showRadioForItem === 'function') {
                return this.showRadioForItem(item);
            }
            return true;
        },
        isRadioVisible(item) {
            return this.showRadio && this.showRadioItem(item);
        },
        onRadioChange() {
            this.$emit('radio', {
                index: this.selectedRadioIndex,
                attribute: this.values[this.selectedRadioIndex].item
            });
        },
        onClose() {
            this.popoverShow = false
        },
        onValueChange(index, value) {
            clearTimeout(this.interval);

            this.interval = setTimeout(() => {
                this.$emit('change', index, value);
            }, 400);
        },
        isOther(value) {
            return ProductIdentifiers.OTHER === value.key;
        },
        isFirst(index) {
            return index === 0;
        },
        typeTitle(value) {
            return this.typeKeyTitleMap[value.key];
        },
        addItem() {
            if (this.selectedType) {
                let value = null;

                if ('Other' === this.selectedType.key) {
                    value = {type: null, value: null};
                }

                this.$emit('add', {
                    key: this.selectedType.key,
                    value: value
                });
                this.selectedType = null;
            }
        },
        removeItem(index, value) {
            this.$emit('remove', index);
        },
        prepareOptions() {
            this.availableOptions = this.options.map(o => o);

            // if (this.values.length > 0) {
            //     let hasSelectedRadio = false;
            //     this.values.forEach((v, _index) => {
            //         let index = this.availableOptions.findIndex(o => o.key === v.key);
            //         if (-1 !== index) {
            //             this.availableOptions.splice(index, 1);
            //         }
            //
            //         if (_index === this.selectedRadioIndex) {
            //             hasSelectedRadio = true;
            //         }
            //     });
            //
            //     if (!hasSelectedRadio) {
            //         this.selectedRadioIndex = 0;
            //         this.onRadioChange();
            //     }
            // }
        },

        isHiddenItemsHaveEmptyValue() {
            const items = this.hiddenItems;
            let hasEmptyValue = false;
            if (items.length) {
                items.forEach(item => {
                    if (!hasEmptyValue) {
                        let value = item.item.value;
                        if (item.item.key === ProductIdentifiers.OTHER || item.item.key === ProductNames.OTHER) {
                            value = item.item.value.value;
                        }

                        if (!value) {
                            hasEmptyValue = true;
                        }
                    }
                });
            }

            return hasEmptyValue;
        },

        onHiddenElementsVisibilityChange(isVisible) {
            const productAttributeHiddenElements = this.$store.getters.runtimeConfig.productAttributeHiddenElements || {};
            productAttributeHiddenElements[this.id] = isVisible;
            this.$store.dispatch('setRuntimeProperty', {
                name: 'productAttributeHiddenElements',
                value: productAttributeHiddenElements
            });
        },
        prepareSelected(selected) {
            return selected.map((item, index) => {
                return {index, item};
            });
        }
    },
    computed: {
        visibleItems() {
            return this.values.filter(this.isAttributeVisible).slice(0, this.numberOfVisibleItems);
        },
        hiddenItems() {
            return this.values.filter(this.isAttributeVisible).slice(this.numberOfVisibleItems);
        },
        isHiddenElementsVisible() {
            const productAttributeHiddenElements = this.$store.getters.runtimeConfig.productAttributeHiddenElements;
            if (productAttributeHiddenElements && productAttributeHiddenElements.hasOwnProperty(this.id)) {
                if (productAttributeHiddenElements[this.id]) {
                    return true;
                }
            }
            return this.isHiddenItemsHaveEmptyValue();
        }
    },
    watch: {
        radioValue() {
            this.selectedRadioIndex = this.radioValue;
        },
        selected(selected) {
            this.values = this.prepareSelected(selected);
            this.prepareOptions();
        },
        options() {
            this.options.forEach(option => {
                this.typeKeyTitleMap[option.key] = option.title;
            });
            this.prepareOptions();
        },
        hiddenItems() {
            if (this.isHiddenItemsHaveEmptyValue()) {
                this.$nextTick(() => {
                    this.$refs.collapsedItems.updateVisible(true);
                });
            }
        }
    },
};
</script>
